<aside #mainSidebar class="main-sidebar sidebar-dark-primary elevation-4">
  <!-- Brand Logo -->
  <a [routerLink]="['/']" class="brand-link">
    <img
      src="assets/img/cerberus.png"
      alt="@bciti/cerberus LOGO"
      class="brand-image img-circle elevation-3"
      style="opacity: 0.8"
    />
    <span class="brand-text font-weight-light">BCITI CERBERUS</span>
  </a>

  <!-- Sidebar -->
  <div class="sidebar">
    <!-- Sidebar Menu -->
    <nav class="mt-2">
      <ul
        class="nav nav-pills nav-sidebar flex-column"
        data-widget="treeview"
        role="menu"
        data-accordion="false"
      >
        <!-- Add icons to the links using the .nav-icon class
             with font-awesome or any other icon font library -->
        <li class="nav-item">
          <a [routerLink]="['/']" class="nav-link">
            <i class="nav-icon fas fa-tachometer-alt"></i>
            <p>Dashboard</p>
          </a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['/status']" class="nav-link">
            <i class="nav-icon fas fa-signal"></i>
            <p>Status</p>
          </a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['/configuration']" class="nav-link">
            <i class="nav-icon fas fa-cogs"></i>
            <p>Configuration</p>
          </a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['/configuration-fixer']" class="nav-link">
            <i class="nav-icon fas fa-wrench"></i>
            <p>Configuration Fixer</p>
          </a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['/menus']" class="nav-link">
            <i class="nav-icon fas fa-stream"></i>
            <p>Menus</p>
          </a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['/logger']" class="nav-link">
            <i class="nav-icon fas fa-clipboard-list"></i>
            <p>Logger</p>
          </a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['/organisations']" class="nav-link">
            <i class="nav-icon fas fa-city"></i>
            <p>Organisations</p>
          </a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['/onboarding']" class="nav-link">
            <i class="nav-icon fas fa-rocket"></i>
            <p>Onboarding</p>
          </a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['/github']" class="nav-link">
            <i class="nav-icon fab fa-github"></i>
            <p>GitHub</p>
          </a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['/rss-validator']" class="nav-link">
            <i class="nav-icon fas fa-rss"></i>
            <p>RSS Validator</p>
          </a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['/messages']" class="nav-link">
            <i class="nav-icon fas fa-comment"></i>
            <p>Messages</p>
          </a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['/notices']" class="nav-link">
            <i class="nav-icon fas fa-envelope"></i>
            <p>Notices</p>
          </a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['/vendors']" class="nav-link">
            <i class="nav-icon fas fa-store"></i>
            <p>Vendors</p>
          </a>
        </li>
      </ul>
    </nav>
    <!-- /.sidebar-menu -->
  </div>
  <!-- /.sidebar -->
</aside>
